var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcSignOut16(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "ic_sign out_16"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 486",
    fill: "rgba(255,255,255,0)",
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 334",
    fill: "#fbd365"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4416",
    d: "M13.016 14.5H7.484A1.486 1.486 0 0 1 6 13.016V10.75a.75.75 0 0 1 1.5 0v2.266L13.016 13 13 2.484 7.484 2.5 7.5 4.75a.75.75 0 0 1-1.5 0V2.484A1.486 1.486 0 0 1 7.484 1h5.532A1.486 1.486 0 0 1 14.5 2.484v10.532a1.486 1.486 0 0 1-1.484 1.484Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Union 15",
    d: "M4.281 10.279a.75.75 0 0 0 0-1.061l-.72-.721h7.193a.75.75 0 0 0 0-1.5H3.561l.721-.721a.75.75 0 0 0-1.061-1.057l-2 2a.754.754 0 0 0 0 1.061l2 2a.743.743 0 0 0 .531.217.729.729 0 0 0 .529-.218Z",
    stroke: "rgba(0,0,0,0)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSignOut16);
export default __webpack_public_path__ + "static/media/ic_sign_out_16.c853be741943f1dbb2205378c5cf9d65.svg";
export { ForwardRef as ReactComponent };